import api from "@/lib/api";

const KEY = "myazbnb_ref";
const WINDOW_MS = 30 * 24 * 60 * 60 * 1000; // 30-day attribution window

// Read ?ref=CODE from the URL, store it (with timestamp), and count the click once.
export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref");
    if (!raw) return;
    const code = raw.trim().toUpperCase();
    if (!code) return;
    const existing = getStored();
    localStorage.setItem(KEY, JSON.stringify({ code, ts: Date.now() }));
    // Only count a click when the code is new or the window lapsed (avoid inflating on refresh)
    if (!existing || existing.code !== code) {
      api.post("/affiliates/track", { code }).catch(() => {});
    }
  } catch {
    /* ignore */
  }
}

function getStored() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.code || !parsed?.ts) return null;
    if (Date.now() - parsed.ts > WINDOW_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

// The valid referral code to attribute a booking to (or null if none/expired).
export function getRefCode() {
  return getStored()?.code || null;
}
